import { useState } from "react";
import { User, ValidationErrors } from "../../types/admin";
import EmailInput from "../InputComponents/EmailInput";
import StringInput from "../InputComponents/StringInput";
import SwitchInput from "../InputComponents/SwitchInput";
import ErrorMessage from "../Utils/ErrorMessage";
import SuccessMessage from "../Utils/SuccessMessage";

interface userComponentProps{
    onChange : (field: keyof User) => (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleSubmit : () => Promise<void>;
    user : User;
    errors : ValidationErrors;
    successMessage : string;
    isUserCreation?: boolean;
}
function UserComponent({
    onChange,
    handleSubmit,
    user,
    errors,
    successMessage,
    isUserCreation = false
}:userComponentProps)
{
    const isFieldValid = (fieldName: string): boolean => {
      return !errors || !errors[fieldName] || errors[fieldName].length === 0;
    };
    return(<div className="user-container">
        <div className="row">
          <div className="col-6 visibility-button">
            <h2 className="container-title">
              User {isUserCreation? 'creation' : 'modification'}
            </h2>
          </div>
        </div>
        <div className="form-container">
          <div className="error-container">
            <SuccessMessage
              message={successMessage}
            />
          </div>
          
          <div className="row">
            <div className="col-sm-12">
              <StringInput
                label={"Name"} 
                textValue={user.name} 
                onChange={onChange("name")} 
                maxLength={100}               
                isValid={isFieldValid('Name')}   
              />
            <ErrorMessage errors={errors["Name"]} />
            </div>

            <div className="col-sm-12">
              <EmailInput
                label={"Email"} 
                textValue={user.email} 
                onChange={onChange("email")} 
                isValid={isFieldValid('Email')}
              />
            <ErrorMessage errors={errors["Email"]} />
            </div>
            {isUserCreation? null : 
              <div className="col-sm-12">
                <StringInput
                  label={"Azure ID"} 
                  textValue={user.azureAdId} 
                  onChange={onChange("azureAdId")} 
                  maxLength={100}               
                  isValid={isFieldValid('AzureAdId')}   
                />
              <ErrorMessage errors={errors["azureAdId"]} />
              <ErrorMessage errors={errors["AzureAdId"]} />
              </div>
            }
            <div className="col-sm-12">
              <SwitchInput
                label={"Is user admin?"} 
                value={user.isAdmin} 
                onChange={onChange("isAdmin")} 
              />
            </div>
          </div>
        
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <input
                className="big-button d-block mx-auto mt-5"
                type="submit"
                value={isUserCreation? "Create user" : "Edit user"}
                onClick={() => handleSubmit()}
              />
            </div>
          </div>
        </div>
      </div>)
}

export default UserComponent;